import React from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Carousel from "react-bootstrap/Carousel";
import Jumbotron from "react-bootstrap/Jumbotron";
import Container from "react-bootstrap/Container";
import slide_one from "./images/slide1.jpg";
import slide_two from "./images/slide2.jpg";
import slide_three from "./images/slide3.jpg";
const Landing = props => {
  // if (props.user.isLoggedIn) {
  //   return <Redirect to="/" />;
  // }

  return (
    <div className="container-fluid">
      <Jumbotron fluid>
        <Container>
          <h1 className="display-4">Customer First E-Commerce Delivery</h1>
          <p className="lead">
            Mile1 integrates into your favourite shopping sites to show as a
            shipping option on eligible orders within downtown Toronto. Shop
            online as you do normally, and select Mile1 at checkout for a better
            online shopping experience.
          </p>
        </Container>
      </Jumbotron>
      {/* <Carousel>
        <Carousel.Item>
          <img className="d-block w-100" src={slide_one} alt="First slide" />
          <Carousel.Caption className="bg-dark">
            <h3>Delivery With Speed</h3>
            <p className="text-center">
              Stop waiting for online orders. Mile1 provides same day and next
              day delivery in downtown Toronto so that you can have what you
              want today, without needing to make the trip to the store.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={slide_two} alt="Third slide" />

          <Carousel.Caption className="bg-dark">
            <h3>On Your Schedule</h3>
            <p className="text-center">
              No more missed deliveries. With Mile1 you decide when we deliver –
              choose a 1-hour delivery window, evenings and weekends included,
              and get what you want when you want it.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={slide_three} alt="Third slide" />

          <Carousel.Caption className="bg-dark">
            <h3>Customer Focused</h3>
            <p className="text-center">
              We’re here to make online shopping as easy as possible for you.
              Provide delivery instructions when ordering and we’ll make sure
              that your order is delivered however works best for you.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel> */}
    </div>
  );
};
const mapStateToProps = ({ user }) => ({
  user: user
});

export default connect(mapStateToProps)(Landing);
